import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessPolicyService } from '../services/access-policy.service';

/** Platform operations need SUPER_ADMIN_MANAGE, not merely system workspace visibility. */
export const superAdminManageGuard: CanActivateFn = () =>
  inject(AccessPolicyService).canManageSuperAdmin()
    ? true
    : inject(Router).createUrlTree(['/dashboard']);
